exports.APIS = {
  Register: {
    SEND_EMAIL_OTP: "/sendOtpEmail",
    VERIFY_EMAIL_OTP: "/vendorotpEmailVerify",
    SEND_PHONE_OTP: "/vendorsendotp",
    VERIFY_PHONE_OTP: "/vendorotpVerify",
    SUBMIT_FORM: "/vendorDetails",
    SUBMIT_DETAILS:"/schoolDetails",
    VERIFY_COUPON:"/couponverify",
    VENDOR_SUBSCRIPTION:"/vendorSubscription"
    
  },



  // mine
  // UserGet: "/common/auth/user-info",
  // ChangePassword: "/common/auth/change-password",

  // Masters: {
  //   Country: "/admin/masters/country",
  // },

  // VolunteerDetail: {
  //   Volunteer: "/website/volunteer/volunteers",
  // },

  Commons: {
    GET_VENDOR_FULL_DETAILS:"/getVendorFullDetails",
    AllCity: "/city",
    AllStates: "/state",
    GET_ALL_SUBSCRIPTION:"/subscriptions",
    GET_ALL_COUPON:"/coupon"
  },

  ContactUs:{
    Contact_Us:"/contactUs"
  }
  // UserManagement: {
  //   Roles: "/admin/employee-management/role",
  //   Builder: "/admin/employee-management/builder",
  //   Users: "/admin/employee-management/user",
  //   Sales: "/admin/employee-management/sales",
  // },
};
